import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useRatingUpdatesFunction = () => {
  const { generalApiCall } = useGeneralApiCall();
  const ratingUpdateFunction = async ({ objectId, importanceRating }) => {
    try {
      return await generalApiCall({
        pathname: '/api/feed/add-feedback-importance-rating',
        method: 'post',
        requestProperties: {
          objectId,
          importanceRating,
        },
        needsAuthentication: true,
        returnCompleteRequest: true,
      });
    } catch (error) {}
  };
  return { ratingUpdateFunction };
};

export default useRatingUpdatesFunction;
